import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/contexts/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminShell from "@/components/AdminShell";
import { ConfirmProvider } from "@/components/Forms";
import LoginPage from "@/pages/Login";
import AdminPasswordResetPage from "@/pages/AdminPasswordReset";
import DashboardPage from "@/pages/Dashboard";
import TenantsPage from "@/pages/Tenants";
import TenantDetailPage from "@/pages/TenantDetail";
import SuperAdminsPage from "@/pages/SuperAdmins";
import AccountPage from "@/pages/Account";
import AdminLeadsPage from "@/pages/Leads";
import AdminLeadDetailPage from "@/pages/LeadDetail";
import DispatcherPage from "@/pages/Dispatcher";
import AuditLogPage from "@/pages/AuditLog";
import HealthPage from "@/pages/Health";
import IntegrationsPage from "@/pages/Integrations";
import SmsNumbersPage from "@/pages/SmsNumbers";
import PromptModulesPage from "@/pages/PromptModules";
import PromptModuleEditorPage from "@/pages/PromptModuleEditor";
import FactsSchemaEditorPage from "@/pages/FactsSchemaEditor";

/**
 * The admin SPA is mounted at /admin/* (Spring AdminUiResourceConfig →
 * classpath:/static/admin/). React Router uses basename="/admin" so deep
 * routes survive hard refresh and the SPA can use root-relative paths
 * like "/" and "/tenants" internally.
 */
export default function App() {
  return (
    <BrowserRouter basename="/admin">
      <AuthProvider>
        <ConfirmProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/password-reset/:token" element={<AdminPasswordResetPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminShell />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/tenants" element={<TenantsPage />} />
                <Route path="/tenants/:slug" element={<TenantDetailPage />} />
                <Route path="/super-admins" element={<SuperAdminsPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/leads" element={<AdminLeadsPage />} />
                <Route path="/leads/:tenant/:id" element={<AdminLeadDetailPage />} />
                <Route path="/dispatcher" element={<DispatcherPage />} />
                <Route path="/audit-log" element={<AuditLogPage />} />
                <Route path="/health" element={<HealthPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                <Route path="/sms-numbers" element={<SmsNumbersPage />} />
                <Route path="/prompt-modules" element={<PromptModulesPage />} />
                <Route path="/prompt-modules/:moduleId" element={<PromptModuleEditorPage />} />
                <Route path="/verticals/:vertical/facts-schema" element={<FactsSchemaEditorPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
